import React, { useEffect, useState } from "react";
import classes from "./ProfileData.module.css";
import { Breadcrumb} from "react-bootstrap";
import { Link, useLocation, useParams } from "react-router-dom";
import Card from "../../../UI/Card/Card";
import Graybg from "../../../UI/Graybg";
import Select from "../../../UI/Select/Select";
import AddProfile from "../AddProfile/AddProfile";
import userService from "../../../app/services/user.service";
import Loader from "../../../UI/loader/loader";
import { toast } from "react-toastify";
import Toast from "../../../UI/Toast/Toast";
import MultiSelectDropdown from "../../../UI/MultiSelectDropdown/MultiSelectDropdown";
import SecBTN from "../../../UI/SecBTN";

const ProfileData = () => {
  const user_id = JSON.parse(localStorage.getItem("user"))?.data?.user?.user_id;
  // const { profileId, profileName } = useParams();
  const {state} = useLocation();
  const { profileId, profileName } = state;
  const [loading, setLoading] = useState(false);
  const [selectProfile, setSelectProfile] = useState(profileId);
  const [profileList, setProfileList] = useState([]);
  const [rightList, setRightList] = useState([]);
  const [rightListByPid, setRightListByPid] = useState([]);

  const getProfileData = ({loader}) => {
    loader && setLoading(true);
    userService
      .getProfileList()
      .then((data) => {
        loader && setLoading(false);
        console.log(data.data.data);
        setProfileList(data.data.data);
      })
      .catch((err) => {
        console.log(err);
        toast.error("Something went wrong");
        loader && setLoading(false);
      });
  };
  const getRightsByPid = () => {
    userService.getRightsByPid(selectProfile)
    .then((data) => {
      console.log(data);
      // setRightListByPid(data.data.data)
      const datas = data.data.data;
      const arr = new Array(datas.length);
      for(let i = 0; i < datas.length; i++) {
         arr[i] = {
          "profile_id": datas[i].profile_id,
          "right_id": datas[i].right_id,
          "right_name": datas[i].TblRight.Rights,
          "insertion_by": datas[i].insertion_by,
          "insertion_on": datas[i].insertion_on,
        }
      }
      setRightListByPid(arr)
    })
    .catch((err) => {
      console.log(err);
    });
  };
  useEffect(() => {
    getProfileData({loader: true});
    getRightsByPid();
    userService
      .getRightList()
      .then((data) => {
        // setRightList(data.data.data);
        console.log("rights",data.data.data);
        let datas = data.data.data;
        let arr = new Array(datas.length);
        for (let i = 0; i < arr.length; i++) {
          arr[i] = { ...datas[i],"profile_id":+selectProfile ,"insertion_by":user_id,"insertion_on":new Date().toISOString()};
        }
        setRightList(arr);
      })
      .catch((err) => {
        console.log(err);
        toast.error("Something went wrong");
      });
  }, [selectProfile]);
  // useEffect(() => {
  //   userService.getRightsByPid(selectProfile)
  //   .then((data) => {
  //     console.log(data);
  //     const datas = data.data.data;
  //     const arr = new Array(datas.length);
  //     for(let i = 0; i < datas.length; i++) {
  //        arr[i] = {
  //         "profile_id": datas[i].profile_id,
  //         "right_id": datas[i].right_id,
  //         "right_name": datas[i].TblRight.Rights,
  //         "insertion_by": datas[i].insertion_by,
  //         "insertion_on": datas[i].insertion_on,
  //       }
  //     }
  //     setRightListByPid(arr)
  //   })
  //   .catch((err) => {
  //     console.log(err);
  //   });
  // },[selectProfile])
  const onMultiSelect = (selectedList) => {
    setRightListByPid(selectedList);
  };
  const onMultiRemove = (selectedList) => {
    setRightListByPid(selectedList);
  };
  const saveRightsHandler = () => {
    console.table(rightListByPid)
    userService
    .updateRightsByPid(rightListByPid,selectProfile)
    .then((data) => {
        console.log(data);
        getRightsByPid();
        toast.success("Rights Saved Successfully");
      })
    .catch((err) => {
        console.log(err);
        toast.error("Something went wrong");
      });
  };
  return (
    <div className="section">
      {loading && <Loader/>}
      <Toast />
      <div className="d-flex justify-content-between align-items-center">
        <div>
          <h4>Profile List</h4>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/profileList">Profile List</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>{profileList.length === 0 ? profileName : profileList.find(x => x.profile_id == selectProfile).profile_name}</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <AddProfile user_id={user_id} />
      </div>
      <Graybg>
        <Card>
          <label>Profile Name :</label>
          <Select
            value={selectProfile}
            onChange={(e) => setSelectProfile(e.target.value)}
          >
            {profileList.map((data) => {
              return (
                <option key={data.profile_id} value={data.profile_id}>
                  {data.profile_name}
                </option>
              );
            })}
          </Select>
        </Card>
        <Card>
        <MultiSelectDropdown
                  placeholder='Select Rights'
                  options={rightList}
                  selectedValues={rightListByPid}
                  displayValue="right_name"
                  onSelect={onMultiSelect}
                  onRemove={onMultiRemove}
                />
        <div className="text-center mt-5 mb-3">
          <SecBTN className="sec-btn1" onClick={saveRightsHandler}>Save</SecBTN>
          </div>
        </Card>
        {/* <Row>
          <Col md={6}>
            <Card>
              <h6 className="mb-3">Available Rights</h6>
              <div className={classes.outline}>
                <Form.Check
                  type={`checkbox`}
                  label={`Wrong Question/Incomplete Solution`}
                  defaultChecked
                />
              </div>
              <div className={classes.outline}>
                <Form.Check
                  type={`checkbox`}
                  label={`Wrong Question/Incomplete Solution`}
                  defaultChecked
                />
              </div>
              <div className={classes.outline}>
                <Form.Check
                  type={`checkbox`}
                  label={`Wrong Question/Incomplete Solution`}
                  defaultChecked
                />
              </div>
              <div className={classes.outline}>
                <Form.Check
                  type={`checkbox`}
                  label={`Wrong Question/Incomplete Solution`}
                  defaultChecked
                />
              </div>
              <div className={classes.outline}>
                <Form.Check
                  type={`checkbox`}
                  label={`Wrong Question/Incomplete Solution`}
                  defaultChecked
                />
              </div>
              <div className="mt-4 text-end">
                <SecBTN className="sec-btn1">Update</SecBTN>
              </div>
            </Card>
          </Col>
          <Col md={6}>
            <Card>
              <h6 className="mb-3">Pending Rights</h6>
              {rightList.map((data) => {
                return (
                  <div className={classes.outline} key={data.right_name}>
                    <Form.Check
                    onChange={e=> console.log(e.target.checked)}
                      value={data.right_id}
                      type={`checkbox`}
                      label={data.right_name}
                    />
                  </div>
                );
              })}
              
              <div className="mt-4 text-end">
                <SecBTN className="sec-btn1">Update</SecBTN>
              </div>
            </Card>
          </Col>
        </Row> */}
      </Graybg>
    </div>
  );
};

export default ProfileData;
